/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `scene_generating` - 씬 프롬프트 생성 중
 * `scenes_ready` - 씬 준비 완료
 * `clip_generating` - 클립 생성 중
 * `clips_ready` - 클립 준비 완료
 * `compositing` - 합성 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type MusicVideoStatusEnum =
  (typeof MusicVideoStatusEnum)[keyof typeof MusicVideoStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MusicVideoStatusEnum = {
  pending: "pending",
  scene_generating: "scene_generating",
  scenes_ready: "scenes_ready",
  clip_generating: "clip_generating",
  clips_ready: "clips_ready",
  compositing: "compositing",
  completed: "completed",
  failed: "failed",
} as const;
